<main class="main-home-secton">
  <div class="event-main">
    <div class="div-header">
      <h1>Initiatives</h1>
    </div>
    <div class="container">
      <div class="event-title"></div>
      <div class="div-contents mt-5" *ngIf="noData == false">
        <div class="row">
          <div
            class="col-lg-4 col-md-6 col-sm-12 col-12"
            *ngFor="let list of disList; let i = index"
          >
            <div class="accordscard-div">
              <div class="blog-img-div">
                <img
                  [src]="list.logoNameURL"
                  alt=""
                  class="img-fluid accordscard-img"
                />
              </div>
              <div class="event-titles">
                <h5>{{ list.title }}</h5>
                <span>{{ list.aboutusTitle }}</span>
                <div class="event-footer mb-2">
                  <div class="border-line"></div>
                  <div class="event-register">
                    <button class="view-btn" (click)="viewEvent(list.title)">
                      View
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pagination-div text-center m-3" *ngIf="totalPages > 1">
          <button
            mat-mini-fab
            color="accent"
            class="set-page mr-2"
            [disabled]="currentPage == 1"
            (click)="paginatePartList('prev')"
          >
            <i class="fas fa-chevron-left"></i>
          </button>
          <button
            mat-mini-fab
            color="accent"
            class="set-page"
            [disabled]="currentPage == totalPages"
            (click)="paginatePartList('next')"
          >
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
      <div class="div-contents" *ngIf="noData == true">
        <div class="text-center no-data-div">
          <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
          <h6>Coming Soon</h6>
        </div>
      </div>
    </div>
  </div>
</main>
<app-footer></app-footer>
